<template>
  <div class="combat-implants-wrapper">
    <div class="combat-implants-titles">
      <div
        v-for="implant in implants"
        :key="implant + 'title'"
        class="combat-implant-title"
        @mouseover="handleInfoPanelData(implant)"
      >
        {{ implant.toUpperCase() }}
      </div>
    </div>
    <div class="combat-implants-buttons">
      <GenericButton
        v-for="implant in implants"
        :key="implant"
        :image-src="require(`@/assets/img/implants/${implant.toLowerCase()}.png`)"
        @mouseover="handleInfoPanelData(implant)"
        @click="implantCombat(implant)"
        :active-level="implantData[implant].level"
        :is-active="!!implantData[implant].level"
        :is-disabled="implantData[implant].disabled"
        width="45px"
        height="26px"
      />
    </div>
  </div>
</template>
<script>
import { useStore } from 'vuex';
import GenericButton from '../shared/GenericButton.vue';
import { computed } from 'vue';
export default {
    name: 'CombatImplants',
    setup() {
        const store = useStore();
        const implants = ['Dermal', 'Phoenix', 'Nemean'];
        const showInfo = (category, stat) => {
            store.dispatch('handleIncomingCommand', {
                command: 'updateInfoPanel',
                data: { category, stat }
            });
        };
        const implantData = computed(() => {
          return implants.reduce((acc, implant) => {
            const level = +store.state.build.CombatImplants[implant + 1].tagged + +store.state.build.CombatImplants[implant + 2].tagged;

            let isAvailable = false;
            if (level === 0) {
              isAvailable = store.state.build.CombatImplants[implant + 1].available;
            } else if (level === 1) {
              isAvailable = store.state.build.CombatImplants[implant + 2].available;
            }

            acc[implant] = {
              level,
              disabled: !isAvailable
            }

            return acc;
          }, {})
        })
        const getCombatImplantData = (implant) => {
            const data = {
                level: +store.state.build.CombatImplants[implant + 1].tagged + +store.state.build.CombatImplants[implant + 2].tagged,
                available: store.state.build.CombatImplants[implant + 1].available || store.state.build.CombatImplants[implant + 2].available,
                style: 'image-combat-implant'
            };
            if (data.available && !data.level) {
                data.style += ' available';
            }
            else if (data.level) {
                if (data.available) {
                    data.style += ' available';
                }
                else {
                    data.style += ' implanted';
                }
            }
            else {
                data.style += ' disabled';
            }
            return data;
        };
        const implantCombat = (implant) => {
            const postfix = store.state.build.CombatImplants[implant + 1].available ? '1' : store.state.build.CombatImplants[implant + 2].available ? '2' : '0';
            if (+postfix) {
                const data = {
                    implant: implant + postfix
                };
                store.dispatch('handleIncomingCommand', {
                    command: 'implantCombat',
                    data: data
                });
                showInfo('CombatImplants', implant + 2);
            }
            else {
                return;
            }
        };
        const handleInfoPanelData = (implant) => {
            const implantLevel = getCombatImplantData(implant).level;
            if (implantLevel) {
                showInfo('CombatImplants', implant + 2);
            }
            else {
                showInfo('CombatImplants', implant + 1);
            }
        };

        return {
            state: store.state,
            implants,
            getCombatImplantData,
            implantCombat,
            showInfo,
            handleInfoPanelData,
            implantData
        };
    },
    components: { GenericButton }
};
</script>
<style scoped>
.combat-implants-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.combat-implants-titles {
  position: relative;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin-bottom: 2px;
}
.combat-implants-buttons {
  position: relative;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin-bottom: 2px;
}
.combat-implant-title {
  width: 33%;
  max-height: 12px;
  text-align: center;
  font-size: 12px;
  color: var(--text-green);
  text-shadow: 1px 1px rgb(48, 41, 41);
  opacity: 0.8;
}
</style>